import { render, staticRenderFns } from "./BidAccumulator.vue?vue&type=template&id=2662bc84&"
import script from "./BidAccumulator.vue?vue&type=script&lang=js&"
export * from "./BidAccumulator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports